import { tw } from "@/utils";

interface ToggleProps {
  options: [string, string];
  selectedOption: string;
  onToggle: (option: string) => void;
}

export const Toggle = ({ options, selectedOption, onToggle }: ToggleProps) => {
  return (
    <div className="inline-flex rounded-full border border-neutral-200 bg-neutral-100 p-1">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={tw(
            "rounded-full px-4 py-1.5 text-sm font-semibold transition-colors",
            selectedOption === option
              ? "bg-white text-primary-800 shadow-sm"
              : "text-neutral-500 hover:text-neutral-800",
          )}
          onClick={() => onToggle(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
